import { useNavigate } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";

const KEY = "daybreak-act-as";

export const getActAs = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; } };
export const startActAs = (u) => { sessionStorage.setItem(KEY, JSON.stringify({ uid: u.user_id, name: u.name || u.email })); window.location.assign("/homework"); };
export const stopActAs = () => sessionStorage.removeItem(KEY);

export const AdminTag = ({ by, id }) => (by ? <span data-testid={id} className="rounded-full border border-brand/60 bg-brand/15 px-2 py-0.5 text-[11px] font-bold text-rose-600">Added by admin</span> : null);

export const ActingBanner = () => {
  const nav = useNavigate();
  const a = getActAs();
  if (!a) return null;
  return (
    <div data-testid="acting-banner" className="sticky top-14 lg:top-20 z-40 mx-auto max-w-6xl px-4 sm:px-6 pt-3">
      <div className="flex items-center gap-3 rounded-2xl bg-brand px-4 py-2.5 text-white shadow-red">
        <ShieldAlert className="w-5 h-5 shrink-0" />
        <p className="flex-1 text-sm"><b>Managing {a.name}'s account.</b> <span className="hidden sm:inline">Homework, tests, timetable, term dates, kit and revision you change here go to them, and they get a notification.</span></p>
        <button data-testid="acting-exit" onClick={() => { const uid = a.uid; stopActAs(); nav(`/admin?u=${uid}`); window.location.reload(); }} className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-black hover:bg-gold-300"><X className="w-3.5 h-3.5" />Exit</button>
      </div>
    </div>
  );
};
